export const emptyArray = [];
